import { ComponentPropsWithoutRef } from 'react';
import { HEIGHTS } from 'shared/styles/variables';
import styled from 'styled-components';

import { fieldSSTStyles, InputComponentTextStyles } from 'inquiry/mixins/form';
import FormControlProps from 'lib/interfaces/FormControlProps';

export type TextAreaProps = ComponentPropsWithoutRef<'textarea'> &
  FormControlProps & {
    styles?: InputComponentTextStyles;
    resize?: 'none' | 'vertical' | 'horizontal' | 'both';
  };

const TextArea = styled('textarea').attrs(() => ({
  // Avoid spell-jacking
  spellCheck: false,
}))<TextAreaProps>`
  ${(props) => fieldSSTStyles(props, props.theme, props.styles)};

  height: ${(props) => (props.rows ? 'unset' : HEIGHTS.textArea)};
  resize: ${(props) => props.resize || 'none'};
`;

export default TextArea;
